import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  margin-top: 20px;

  h1 {
    font-size: 31px;
  }

  a {
    font-size: 18px;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/NotFound/styles.js